// import then needed Font Awesome functionality
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

config.searchPseudoElements = true;

// import the Facebook and Twitter icons
import {
    faFacebookF,
    faLinkedinIn,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons';

import {
    faCaretDown,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faSearch,
    faTimes,
    faExternalLinkAlt,
    faCopy,
    faPlay,
} from '@fortawesome/free-solid-svg-icons';


import {
    faFile,
    faFilePdf,
    faFilePowerpoint,
    faFileWord,
    faFileAudio,
    faFileVideo,
    faFileCode,
    faFileImage,
    faFileAlt,
} from '@fortawesome/free-regular-svg-icons';

// add the imported icons to the library
library.add(
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faCaretDown,
    faChevronDown,
    faSearch,
    faTimes,
    faChevronLeft,
    faChevronRight,
    faSearch,
    faExternalLinkAlt,
    faCopy,
    faPlay,
    faFile,
    faFileAlt,
    faFilePdf,
    faFilePowerpoint,
    faFileAudio,
    faFileVideo,
    faFileCode,
    faFileWord,
    faFileImage
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fortawesome.js